import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { capitalizeName } from 'Utils/label/labelUtils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import { Tooltip } from 'Components/frameworks/tooltip/Tooltip';
import { themes } from 'Components/widgets/be-transport-details/BeTransportDetails.themes';
type TransportDetailsOperatorProps = {
  theme: 'mobile' | 'desktop';
  transportDetailEnriched: TransportDetailEnriched;
  companyOperatorsName: Array<string>;
};

const OperatorTooltip = ({ className }: { className: string }) => (
  <Tooltip
    modalProps={{
      closeLabel: t('common.close'),
      size: 'small',
      children: null,
    }}
    renderTrigger={(toggle) => (
      <button className={classnames('relative ml-2', className)} onClick={toggle} type="button">
        <Icon name={ICONS.INFORMATION} width="1.25rem" />
      </button>
    )}
  >
    <Text className="mb-10 p-20 text-12" text={t('common.transport.operatedByInfo')} />
  </Tooltip>
);

export const TransportDetailsOperator = ({
  theme,
  transportDetailEnriched,
  companyOperatorsName,
}: TransportDetailsOperatorProps) => {
  const { thOperator, thOperatorInfoButton } = themes()[theme];
  const isSameOperatorAndExploiter =
    transportDetailEnriched.transport.companyOperator?.id ===
    transportDetailEnriched.transport.companyExploiter?.id;
  return (
    <div
      className={classnames('w-4/5 gap-4 text-14 font-semibold', thOperator)}
      data-testid="TransportDetailsOperator"
    >
      {companyOperatorsName.length > 1 ? (
        <div>{companyOperatorsName.join(' - ')}</div>
      ) : (
        <React.Fragment>
          <div>{capitalizeName(transportDetailEnriched.transport.companyExploiter?.label)}</div>
          {!isSameOperatorAndExploiter && (
            <React.Fragment>
              <span>
                {t('booking.transport.planeTicket.operatedBy')}&nbsp;
                {capitalizeName(transportDetailEnriched.transport.companyOperator?.label)}
              </span>
              <OperatorTooltip className={thOperatorInfoButton} />
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
};
